import { Component, OnInit, signal } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { CurrentUserService } from '@core/services/currentUser.service';
import { AgentsService } from './agents.service';

@Component({
  selector: 'app-agents-iframe',
  standalone: true,
  template: `
    @if (isLoading()) {
      <div class="flex items-center justify-center" style="min-height: calc(100vh - 100px);">
        <span class="pi pi-spin pi-spinner" style="font-size: 2rem; color: var(--pay-primary)"></span>
      </div>
    } @else if (error()) {
      <div class="flex items-center justify-center" style="min-height: calc(100vh - 100px);">
        <p style="color: var(--pay-danger-fg); font-size: 13px;">{{ error() }}</p>
      </div>
    } @else if (safeUrl()) {
      <div class="w-full h-full border-none overflow-hidden" style="min-height: calc(100vh - 100px);">
        <iframe
          [src]="safeUrl()!"
          class="border-none"
          allow="autoplay; camera; microphone; fullscreen; display-capture; clipboard-read; clipboard-write"
        ></iframe>
      </div>
    }
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        height: 100%;
      }

      iframe {
        width: 100%;
        height: 100%;
        min-height: calc(100vh - 100px);
      }
    `,
  ],
})
export class AgentsIframeComponent implements OnInit {
  safeUrl = signal<SafeResourceUrl | null>(null);
  isLoading = signal(true);
  error = signal<string | null>(null);

  constructor(
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private currentUserService: CurrentUserService,
    private agentsService: AgentsService
  ) {}

  async ngOnInit(): Promise<void> {
    const tenantId = this.route.snapshot.queryParams['tenant'];

    if (!tenantId) {
      this.error.set('No tenant provided.');
      this.isLoading.set(false);
      return;
    }

    const expiresAt = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString();
    const language = this.currentUserService.getCurrentLanguage();

    try {
      const url = await this.agentsService.getVoiceWatchDashboardUrl({ tenantId, expiresAt, language });
      this.safeUrl.set(this.sanitizer.bypassSecurityTrustResourceUrl(url));
    } catch {
      this.error.set('Could not load the dashboard. Please try again later.');
    } finally {
      this.isLoading.set(false);
    }
  }
}
